import { MONDAY, SUNDAY, TUESDAY } from "../../constants/days";

//TYPES
export class HourRange
{
    startHour: string;
    endHour: string;
}
export class HourRanges
{
    prevRange: HourRange = null;
    currRange: HourRange = null;
    nextRange: HourRange = null;
}

export class AvailableTimes
{
    id: string;
    hour: string; //hh:mm
}

export class Days
{
    id: string;
    day: string;
    availableTimes: AvailableTimes[];
}

export class Rendered
{
    prev: Days = { id: null, day: SUNDAY, availableTimes: [] };
    curr: Days = { id: null, day: MONDAY, availableTimes: [] };
    next: Days = { id: null, day: TUESDAY, availableTimes: [] };
}

export class SaveAvailableAppointmentDayDTO
{
    doctorId: string;
    day: string;
    availableTimes: [];
}